import runAfterPageLoad from "./runAfterPageLoad";

export function sessionPopup() {
  const SESSION_EXPIRE_INTERVAL_CHECK_IN_MILISECONDS = 10000; // 10 seconds

  runAfterPageLoad(() => {
    setInterval(() => {
      const sessionPopupElement = document.querySelector("#session-popup");
      if (!sessionPopupElement) return;
      // isSessionAboutToExpire() is simple function which checks if token exp date in sessionStorage is less than current date + 10 minutes
      const sessionStatus = getSessionStatus();
      if (sessionStatus !== "valid") {
        sessionPopupElement.classList.add("open");
        const requestTokenBtn = sessionPopupElement.querySelector(
          "button#request-token"
        );

        requestTokenBtn.removeEventListener("click", redirectToLoginScreen);
        requestTokenBtn.removeEventListener("click", requestNewTokenListener);
        const buttonText =
          sessionStatus === "expired"
            ? $(requestTokenBtn).attr("data-expired")
            : $(requestTokenBtn).attr("data-extend");
        if (requestTokenBtn.textContent !== buttonText) {
          requestTokenBtn.textContent = buttonText;
        }

        if (sessionStatus === "expired") {
          requestTokenBtn.addEventListener("click", redirectToLoginScreen);
        } else {
          requestTokenBtn.addEventListener("click", requestNewTokenListener);
        }
      }
    }, SESSION_EXPIRE_INTERVAL_CHECK_IN_MILISECONDS);
  });
}

async function requestNewTokenListener() {
  const sessionPopupElement = document.querySelector("#session-popup");
  if (!sessionPopupElement) return;
  sessionPopupElement.classList.remove("open");

  const expiration = await requestNewToken();
  sessionStorage.setItem("exp", expiration);
}

async function requestNewToken() {
  const tokenElement = document.querySelector("[name=csrf-token]");
  const token = tokenElement ? tokenElement.content : null;

  const response = await fetch("/api/refresh_session", {
    credentials: "same-origin",
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": token,
    },
  });

  if (response.status === 401 || response.status === 422) {
    window.location.reload();
  } else {
    const data = await response.json();
    return data.new_exp;
  }

  return true;
}

function redirectToLoginScreen() {
  window.location.replace("/users/sign_in");
}

function getSessionStatus() {
  // unauthenticated public page
  if (sessionStorage.getItem("exp") === "") {
    return "valid";
  }

  const exp = Number(sessionStorage.getItem("exp"));
  const date = new Date(0);
  date.setUTCSeconds(exp);
  const currentDate = new Date();
  if (currentDate.valueOf() > date.valueOf()) {
    return "expired";
  }

  currentDate.setMinutes(currentDate.getMinutes() + 10);
  return currentDate.valueOf() >= date.valueOf() ? "extend" : "valid";
}
